import {
	IAtribitcpa,
	IAttributeSale,
	ICancelAttributesParams,
	IConfirmAttributesParams,
	IGetAttributesParams,
	IGetAttributesResponse
} from 'models/Attributes'

export enum IFormType {
	SALES = 'SALES',
	PURCHASES = 'PURCHASES'
}

type IFormTypeText = IFormType.SALES | IFormType.PURCHASES

export interface IAttributesModalState {
	attributeStateList: IAtribitcpa[]
	attribData: Partial<IAttributeSale>[]
}

export interface IAttributesModalProps {
	idOperacion: string
	it: string
	typeForm: IFormTypeText
	attributeList: IGetAttributesResponse
	getAttributes: (payload: IGetAttributesParams) => void
	cancelAttributes: (payload: ICancelAttributesParams) => void
	cancelPurchasesAttributes: (payload: ICancelAttributesParams) => void
	confirmAttributes: (payload: IConfirmAttributesParams) => void
	confirmPurchasesAttributes: (payload: IConfirmAttributesParams) => void
	getPurchasesAttributes: (payload: IGetAttributesParams) => void
}

export interface IAttributesModalFormProps {
	attributeList: any
	handleCancelAttributes: () => void
	handleConfirmAttributes: () => void
	handleChangeData: (data: Partial<IAttributeSale>) => void
}

export interface IAttributesModalFormState {
	attribData: Partial<IAttributeSale>[]
}
